var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var ModalBehavior = Marionette.Behavior.extend({
  triggers: {
    'click .js-cancel': 'dialog:close',
    'click .js-submit': 'form:submit',
    'click .js-delete': 'modal:delete'
  },
  // Behaviors have events that are bound to the views DOM.
  events: {
    'click .close': 'onClickClose'
  },
  onClickClose: function (ev) {
    this.closeModal()
  },
  closeModal: function () {
    this.view.trigger('dialog:close')
  }
})

module.exports = ModalBehavior



// WEBPACK FOOTER //
// ./js/behaviors/modal-behavior.js